import { Component } from '@angular/core';
import { navbarMenus } from './menuName';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { Accordion } from '../accordion/accordion';
import { HasRolesDirective } from 'keycloak-angular';

@Component({
  selector: 'app-navbar',
  imports: [RouterLink, NgClass, NgOptimizedImage, RouterLinkActive, Accordion, HasRolesDirective],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export class Navbar {
  menuItems = navbarMenus;
  isCollapsed = true;
  fixed = false;

  accordionSections = {
    title: 'Admin',
    content: [
      { label: '1', path: '1' },
      { label: '2', path: '2' },
    ],
    open: true,
  };

  constructor() {
    const fixedStatus = localStorage.getItem('navFixed');
    if (fixedStatus) {
      this.fixed = fixedStatus == 'true';
      if (this.fixed) {
        this.isCollapsed = false;
      }
    }
  }

  openSidebar() {
    if (!this.fixed) this.isCollapsed = false;
  }

  closeSidebar() {
    if (!this.fixed) this.isCollapsed = true;
  }

  toggleFixed() {
    this.fixed = !this.fixed;
    localStorage.setItem('navFixed', `${this.fixed}`);
  }
}
